import { render, staticRenderFns } from "./social-link-form.vue?vue&type=template&id=3ab23da2&scoped=true"
import script from "./social-link-form.vue?vue&type=script&lang=js"
export * from "./social-link-form.vue?vue&type=script&lang=js"
import style0 from "./social-link-form.vue?vue&type=style&index=0&id=3ab23da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab23da2",
  null
  
)

export default component.exports